import { wsUrl } from './api.js';

export class GameClient {
  constructor() {
    this.ws = null;
    this.handlers = new Set();
    this.code = null;
  }

  connect(code) {
    this.disconnect();
    this.code = code;
    return new Promise((resolve, reject) => {
      const ws = new WebSocket(wsUrl(code));
      this.ws = ws;

      const onOpen = () => {
        cleanup();
        resolve();
      };
      const onError = () => {
        cleanup();
        reject(new Error('Could not connect to game server'));
      };
      const cleanup = () => {
        ws.removeEventListener('open', onOpen);
        ws.removeEventListener('error', onError);
      };

      ws.addEventListener('open', onOpen);
      ws.addEventListener('error', onError);
      ws.addEventListener('message', (e) => {
        try {
          const msg = JSON.parse(e.data);
          for (const h of this.handlers) h(msg);
        } catch {
          /* ignore */
        }
      });
      ws.addEventListener('close', () => {
        if (this.ws === ws) this.ws = null;
      });
    });
  }

  onMessage(handler) {
    this.handlers.add(handler);
    return () => this.handlers.delete(handler);
  }

  send(msg) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      throw new Error('Not connected');
    }
    this.ws.send(JSON.stringify(msg));
  }

  join(playerId, name) {
    this.send({ type: 'join', playerId, name });
  }

  start() {
    this.send({ type: 'start' });
  }

  slap(proofUrl) {
    this.send({ type: 'slap', proofUrl });
  }

  rematch() {
    this.send({ type: 'rematch' });
  }

  disconnect() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }
}
